module.exports = __webpack_public_path__ + "img/blue-glow.8fc3a145.svg";